<template>
  <div v-if="!alertSuggestion" class="row">
    <div class="grid grid-cols-12 mb-4 gap-2">
      <div class="select-wrapper lg:col-span-2 md:col-span-3 sm:col-span-3">
        <VaInput
          v-model="searchQuery"
          type="text"
          class="select-search"
          :placeholder="domainStore.domain"
          @input="filterDomains()"
        />
        <div
          v-if="searchQuery && domain"
          class="options-list va-select-option-list va-select-dropdown__options-wrapper"
        >
          <div v-for="(d, index) in domains" :key="index" class="option" @click="setDomain(d)">
            {{ d }}
          </div>
          <div v-if="domains.length === 0">
            <VaButton class="w-full" :size="'small'" @click="showModal = !showModal"> Add this domain + </VaButton>
          </div>
        </div>
      </div>
      <div v-if="!alerts" class="lg:col-span-3 md:col-span-3 sm:col-span-4">
        <DateRange />
      </div>
      <!-- <div></div> -->
      <!-- <div class="lg:col-span-2 md:col-span-3 sm:col-span-6 ml-8 mt-2">Data Relevancy</div> -->
      <div v-if="!alert" class="lg:col-span-7 md:col-span-6 sm:col-span-6 ml-8 mt-2">
        <EmojiSlider :relivancy="domainStore.relivancy" />
      </div>
      <div v-else class="lg:col-span-3 md:col-span-3 sm:col-span-4">
        <VaButton preset="primary" class="mb-2 font-normal" @click="openAlertModal"> Set Alert </VaButton>
      </div>
    </div>
  </div>
  <!-- For alert sunggestion pop up starts -->

  <div v-else class="row">
    <div class="flex justify-center gap-8">
      <div class="select-wrapper">
        <VaInput
          v-model="searchQuery"
          type="text"
          class="select-search"
          :placeholder="domainStore.domain"
          @input="filterDomains()"
        />
        <div
          v-if="searchQuery && domain"
          class="options-list va-select-option-list va-select-dropdown__options-wrapper"
        >
          <div v-for="(d, index) in domains" :key="index" class="option" @click="setDomain(d)">
            {{ d }}
          </div>
        </div>
      </div>
      <!-- <div class="lg:col-span-2 md:col-span-3 sm:col-span-6 ml-8 mt-2">Data Relevancy</div> -->
      <div class="">
        <VaButton preset="primary" class="mb-2 font-normal" @click="openAlertModal"> Set Alert </VaButton>
      </div>
    </div>
  </div>

  <!-- For alert sunggestion pop up ends  -->
  <VaModal v-if="!alert && !alertSuggestion" v-slot="{ hide }" v-model="showModal" :size="'small'" hide-default-actions>
    <div class="flex flex-col items-start gap-2">
      <h5 class="va-h5">Add domain for monitoring</h5>
      <div v-if="addLoader" class="w-full text-center">Adding domain ...</div>
      <VaInput v-else v-model="addDomain" disabled outline />
    </div>

    <div class="flex justify-end mt-2 gap-2">
      <VaButton preset="secondary" color="secondary" @click="hide()"> Cancel </VaButton>
      <VaButton @click="addNewDomain()"> Add </VaButton>
    </div>
  </VaModal>
  <AlertModal ref="showAlertModal" @alertSet="emit('alertSetEmit')" />
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { useDomainStore } from '../stores/dashBoardStore'
import DateRange from '../pages/admin/dashboard/DateRange.vue'
import { fetchData } from '../data/api/fetchData'
import { useToast } from 'vuestic-ui'
import { postDataAuth } from '@/data/api/fetchData'
import EmojiSlider from './EmojiSlider.vue'
import AlertModal from './AlertModal.vue'

const emit = defineEmits(['alertSetEmit'])
const domainStore = useDomainStore()
const domain = ref(domainStore.domain)
const showModal = ref(false)
const { init } = useToast()
const searchQuery = ref()
const options = ref([])
const domains = ref([])
const addDomain = ref(searchQuery.value)
const addLoader = ref(false)
const favicon = ref()
const searchNewDomain = ref(false)
const props = defineProps(['alerts', 'alertSuggestion'])
const showAlertModal = ref()
const alert = props.alerts

const setDomain = (d) => {
  searchQuery.value = null
  localStorage.setItem('lastSearchDomain', d)
  domainStore.updateDomain(d)
  searchNewDomain.value = false
}

if (!localStorage.getItem('lastSearchDomain')) {
  searchNewDomain.value = true
}

const domainRegex = /^(?!-)(?:[A-Za-z0-9-]{1,63}\.)*(?<!-)[A-Za-z0-9-]{1,63}\.[A-Za-z]{2,6}(?:\.[A-Za-z]{2,6})?$/
const isValidDomain = (dom) => domainRegex.test(dom)

const addNewDomain = async () => {
  addLoader.value = true
  if (isValidDomain(addDomain.value) === false) {
    init({ message: 'Invalid domain', color: 'danger' })
    addLoader.value = false
    return
  }
  const data = {
    domain: addDomain.value,
  }
  try {
    await postDataAuth(`sys/missing_domain`, data)
    init({ message: 'Domain added successfully', color: 'success' })
  } catch (error) {
    console.log(error)
  }
  addLoader.value = false
  showModal.value = false
  searchQuery.value = null
}

const filterDomains = () => {
  if (!searchQuery.value) {
    domains.value = options.value
  } else {
    const searchLower = searchQuery.value.toLowerCase()
    domains.value = options.value.filter((i) => i.toLowerCase().includes(searchLower)).slice(0, 10)
  }
}

const extractDomain = (subdomain) => {
  const parts = subdomain.split('.')
  const domain = parts.slice(-2).join('.')
  return domain
}

const openAlertModal = () => {
  showAlertModal.value.toggleAddAlertModal()
}

// watchers and life cycle hooks below

watch(
  () => searchQuery.value,
  () => {
    addDomain.value = searchQuery.value
  },
)

watch(
  () => domain.value,
  () => {
    setDomain(domain.value)
    favicon.value = `https://www.google.com/s2/favicons?domain=${extractDomain(domainStore.value)}&sz=200`
  },
)

onMounted(async () => {
  favicon.value = `https://www.google.com/s2/favicons?domain=${extractDomain(domainStore.domain)}&sz=200`
  const response = await fetchData('sys/domainList')
  if (response.data) {
    options.value = response.data
  }
  domainStore.updateDomain(domain.value)
  domains.value = options.value.slice(0, 10)
})
</script>
<style scoped>
.select-wrapper {
  position: relative;
  border-radius: 4px;
  background-color: none;
  z-index: 999;
}
.options-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}
.option {
  padding: 8px;
  cursor: pointer;
}
.option:hover {
  background-color: inherit;
}
/* .override > .va-input-wrapper {
  display: none !important;
} */
</style>
